// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.92.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._search-highlight-block{display:inline}._search-highlight-block ._keyword{background:var(--console-warn-background);color:var(--console-warn-foreground)}", ""]);
// Exports
module.exports = exports;
